import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import ResponseHandler from '@/api/response/ResponseHandler'
import apiClient from '@/api/ApiClient'

class RestaurantChargesApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/restaurants-charges'
    }

    get(id) {
        return ResponseHandler.handle(apiClient.get(this.getItemIri(id)))
    }

    list(orderId) {
        return ResponseHandler.handle(
            apiClient.get(
                `${this.getBaseUrl()}?ordering=${this.getItemIri(orderId)}`
            )
        )
    }
    save(data) {
        return ResponseHandler.handle(
            apiClient.post(`${this.getBaseUrl()}`, data)
        )
    }
}

export default new RestaurantChargesApiClient()
